module.exports = __webpack_public_path__ + "static/img/comfirBtnGathai.c7b68d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/comfirBtnGathai.png
// module id = bXZk
// module chunks = 1